(function () {
  'use strict';

  var HOST_SELECTOR = 'main .vtl-proxy-page-wishlist';
  var PRODUCT_SELECTOR = '.Vtl-WishlistProduct';
  var UI_ATTRIBUTE = 'data-zz-wishlist-ui';
  var READY_ATTRIBUTE = 'data-zz-wishlist-state';
  var maxHydrationWait = 4000;

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (text) element.textContent = text;
    element.setAttribute(UI_ATTRIBUTE, 'true');
    return element;
  }

  function createLink(className, href, text) {
    var link = createElement('a', className, text);
    link.href = href;
    return link;
  }

  function createHeartIcon() {
    var wrapper = createElement('div', 'zz-wishlist-page__empty-icon');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.innerHTML = '<svg viewBox="0 0 48 48" fill="none" focusable="false"><path d="M24 41s-15-9.2-15-20.2C9 15.4 12.8 12 17.2 12c2.9 0 5.4 1.5 6.8 3.9C25.4 13.5 27.9 12 30.8 12 35.2 12 39 15.4 39 20.8 39 31.8 24 41 24 41z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path></svg>';
    return wrapper;
  }

  function createHeader() {
    var header = createElement('header', 'zz-wishlist-page__header');
    var eyebrow = createElement('span', 'zz-wishlist-page__eyebrow', 'Your Saved Pieces');
    var heading = createElement('h1', 'zz-wishlist-page__heading', 'Wishlist');
    heading.setAttribute('data-zz-wishlist-heading', 'true');
    var subtext = createElement('p', 'zz-wishlist-page__subtext', 'Save your favorite products for later');
    var count = createElement('span', 'zz-wishlist-page__count');
    count.setAttribute('aria-live', 'polite');
    count.setAttribute('aria-atomic', 'true');
    count.hidden = true;
    count.setAttribute('data-zz-wishlist-count', 'true');
    header.append(eyebrow, heading, subtext, count);
    return header;
  }

  function createEmptyState() {
    var empty = createElement('section', 'zz-wishlist-page__empty');
    empty.hidden = true;
    empty.setAttribute('data-zz-wishlist-empty', 'true');
    empty.appendChild(createHeartIcon());
    empty.appendChild(createElement('h2', 'zz-wishlist-page__empty-title', 'Your Wishlist is empty'));
    empty.appendChild(
      createElement(
        'p',
        'zz-wishlist-page__empty-text',
        'Tap the heart on any fabric, panel or appliqué to save it here, so you can come back to it when you’re ready to order.'
      )
    );

    var actions = createElement('div', 'zz-wishlist-page__empty-actions');
    var cta = createLink('zz-wishlist-page__cta', '/collections/all', 'Explore Collections');
    cta.innerHTML = '<span>Explore Collections</span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
    actions.appendChild(cta);
    empty.appendChild(actions);

    var chips = createElement('nav', 'zz-wishlist-page__chips');
    chips.setAttribute('aria-label', 'Explore collections');
    [
      ['/collections/beaded-fabric', 'Beaded Fabrics'],
      ['/collections/panel-fabrics', 'Panel Fabrics'],
      ['/collections/bodice-appliques', 'Bodice Appliqués'],
      ['/collections/embellished-trims', 'Embellished Trims']
    ].forEach(function (chip) {
      chips.appendChild(createLink('zz-wishlist-page__chip', chip[0], chip[1]));
    });
    empty.appendChild(chips);
    return empty;
  }

  function createFallbackState() {
    var fallback = createElement(
      'p',
      'zz-wishlist-page__fallback',
      'Your Wishlist is temporarily unavailable. Please refresh and try again.'
    );
    fallback.hidden = true;
    fallback.setAttribute('role', 'status');
    fallback.setAttribute('data-zz-wishlist-fallback', 'true');
    return fallback;
  }

  function ensurePresentation(root) {
    var header = root.querySelector('[data-zz-wishlist-header]');
    if (!header) {
      header = createHeader();
      header.setAttribute('data-zz-wishlist-header', 'true');
      root.insertBefore(header, root.firstChild);
    }

    var empty = root.querySelector('[data-zz-wishlist-empty]');
    if (!empty) {
      empty = createEmptyState();
      root.insertBefore(empty, root.children[1] || null);
    }

    var fallback = root.querySelector('[data-zz-wishlist-fallback]');
    if (!fallback) {
      fallback = createFallbackState();
      root.insertBefore(fallback, root.children[2] || null);
    }

    return {
      header: header,
      count: header.querySelector('[data-zz-wishlist-count]'),
      empty: empty,
      fallback: fallback
    };
  }

  function hideNativePresentation(root) {
    root.querySelectorAll('h1:not([data-zz-wishlist-heading])').forEach(function (heading) {
      heading.hidden = true;
      heading.setAttribute('data-zz-wishlist-native-heading', 'true');
    });

    root.querySelectorAll('h2, h3, p, [role="status"]').forEach(function (element) {
      if (element.hasAttribute(UI_ATTRIBUTE) || element.hidden) return;
      var text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        (text.indexOf('wishlist') !== -1 && text.indexOf('empty') !== -1) ||
        text.indexOf('save your favorite products for later') !== -1
      ) {
        element.hidden = true;
        element.setAttribute('data-zz-wishlist-native-empty', 'true');
      }
    });
  }

  function findProductGrid(products, root) {
    if (!products.length) return null;
    var parent = products[0].parentElement;
    if (!parent || parent === root) return parent === root ? root : null;
    return products.every(function (product) {
      return product.parentElement === parent;
    }) ? parent : null;
  }

  function syncProductGrid(root, products, previousGrid) {
    if (previousGrid) {
      previousGrid.classList.remove('zz-wishlist-page__product-grid');
    }

    var grid = findProductGrid(products, root);
    if (grid) grid.classList.add('zz-wishlist-page__product-grid');
    return grid;
  }

  function hasVisibleSpinner(root) {
    return Array.prototype.some.call(root.querySelectorAll('.Vtl-Spinner'), function (spinner) {
      var styles = window.getComputedStyle(spinner);
      return styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0';
    });
  }

  function hasAppRendered(root) {
    if (root.querySelector(PRODUCT_SELECTOR) || hasVisibleSpinner(root)) return true;
    return Array.prototype.some.call(root.querySelectorAll('h1, h2, h3, p, [role="status"]'), function (element) {
      if (element.hasAttribute(UI_ATTRIBUTE) || element.hidden) return false;
      var text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      return (
        text.indexOf('wishlist') !== -1 ||
        text.indexOf('empty') !== -1 ||
        text.indexOf('save your favorite products for later') !== -1
      );
    });
  }

  function init(root) {
    if (!root || root.dataset.zzWishlistInitialized === 'true') return;
    root.dataset.zzWishlistInitialized = 'true';

    var presentation = ensurePresentation(root);
    var grid;
    var hydrated = false;
    var fallbackState = false;
    var startedAt = Date.now();
    var syncTimer;
    var page = root.closest('main');
    var pendingLoader = page && page.querySelector('[data-zz-wishlist-pending-loader]');

    function revealPage() {
      if (page) {
        page.classList.remove('wishlist-page--pending');
        page.classList.add('wishlist-page--ready');
        page.removeAttribute('aria-busy');
      }
      if (pendingLoader) pendingLoader.hidden = true;
    }

    function sync() {
      presentation = ensurePresentation(root);
      var products = Array.prototype.slice.call(root.querySelectorAll(PRODUCT_SELECTOR));
      var spinner = hasVisibleSpinner(root);
      var appRendered = hasAppRendered(root);
      hideNativePresentation(root);

      if (!hydrated && !spinner && (appRendered || Date.now() - startedAt >= maxHydrationWait)) {
        hydrated = true;
        fallbackState = !appRendered;
      }

      if (!hydrated) {
        root.setAttribute(READY_ATTRIBUTE, 'loading');
        presentation.count.hidden = true;
        presentation.empty.hidden = true;
        return;
      }

      var count = products.length;
      fallbackState = fallbackState && !products.length && !appRendered;
      root.setAttribute(READY_ATTRIBUTE, fallbackState ? 'fallback' : count ? 'populated' : 'empty');
      presentation.count.hidden = fallbackState;
      presentation.count.textContent = count + (count === 1 ? ' item' : ' items');
      presentation.empty.hidden = fallbackState || count !== 0;
      presentation.fallback.hidden = !fallbackState;
      grid = syncProductGrid(root, products, grid);
      root.classList.add('zz-wishlist-page--visible');
      revealPage();
    }

    var observer = new MutationObserver(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(sync, 80);
    });
    observer.observe(root, { childList: true, subtree: true });
    sync();
    setTimeout(sync, maxHydrationWait + 40);
  }

  function start() {
    var root = document.querySelector(HOST_SELECTOR);
    if (root) {
      init(root);
      return;
    }

    var attempts = 0;
    var retry = function () {
      var host = document.querySelector(HOST_SELECTOR);
      if (host) {
        init(host);
      } else if (attempts++ < 20) {
        window.setTimeout(retry, 100);
      }
    };
    retry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
